import { render, staticRenderFns } from "./CompetitionLogo.vue?vue&type=template&id=04210986&scoped=true"
import script from "./CompetitionLogo.vue?vue&type=script&lang=ts"
export * from "./CompetitionLogo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04210986",
  null
  
)

export default component.exports